module.exports = __webpack_public_path__ + "img/2003_L.3b6210c6.png";